// #5 Cadeia de Custódia (FP-CMP-011) — inventário de integridade dos anexos
// cifrados (contentHash SHA-256 + sizeBucket). Pass 1: SÓ o inventário de
// integridade (o hash É a âncora de custódia). A trilha de acesso (quem/quando,
// via audit) fica como enriquecimento posterior. ZERO conteúdo decifrado.

import type { FormBlock } from './form-pdf.js';
import { manualField } from './form-pdf.js';
import { type FormInput, categoriaLabel } from './forms-common.js';

export function buildCustodia(input: FormInput): FormBlock[] {
  const blocks: FormBlock[] = [
    { kind: 'title', text: 'Cadeia de Custódia' },
    { kind: 'section', text: 'Identificação' },
    { kind: 'field', label: 'Processo (protocolo):', value: input.caseId },
    { kind: 'field', label: 'Categoria:', value: categoriaLabel(input.categoria) },
    { kind: 'section', text: 'Inventário de evidências (anexos cifrados)' },
  ];

  if (input.attachments.length === 0) {
    blocks.push({ kind: 'paragraph', text: 'Nenhum anexo registrado para este processo.' });
  } else {
    input.attachments.forEach((a, i) => {
      blocks.push(
        { kind: 'field', label: `Anexo ${String(i + 1)} — tamanho:`, value: a.sizeBucket },
        { kind: 'field', label: 'Hash de integridade (SHA-256):', value: a.contentHash },
      );
    });
    blocks.push({
      kind: 'paragraph',
      text:
        'A integridade de cada evidência é ancorada pelo hash SHA-256 do conteúdo ' +
        'cifrado, registrado no momento do upload. Qualquer alteração do arquivo ' +
        'invalida o hash. A trilha de acesso (quem acessou e quando) consta no log ' +
        'de auditoria encadeado do canal.',
    });
  }

  blocks.push(
    { kind: 'section', text: 'Observações' },
    manualField('Observações da custódia:'),
    { kind: 'spacer', mm: 6 },
    { kind: 'signature', nome: '', papel: 'Responsável pela custódia' },
  );

  return blocks;
}
